import blueBgImage from "assets/images/bg-sign-up-blue.jpg";
import { Button } from "components/Button";
import type { ThemeProps as Props } from "models/styles/theme";
import styled from "styled-components/macro";
import { Box } from "styles/helpers/layout";

export const StyledPageLayout = styled.div<Props>`
  min-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 3rem;
  background: url(${blueBgImage}) no-repeat center center;
  background-size: cover;
`;

export const StyledContainer = styled.main<Props>`
  width: 45rem;
  max-width: 100%;
  background: ${(props) => props.theme.palette.neutral.white};
  padding: 4rem 5rem;
  border-radius: ${(props) => props.theme.borderRadius.rounded};
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

export const StyledHeader = styled.div<Props>`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  
  h1 {
    margin-bottom: 1rem;
  }
`;

export const StyledOptionsCard = styled(Box)<Props>`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 1.5rem;
  border-radius: ${(props) => props.theme.borderRadius.rounded};
`;

export const StyledText = styled(Box)<Props>`
  margin-top: 1.5rem;
  
  p {
    margin-bottom: 1.25rem;
    font-size: ${(props) => props.theme.font.size._16};
    line-height: 1.5;
  }
  
  b {
    font-weight: ${(props) => props.theme.font.weight.bold};
  }
`;

export const StyledButton = styled(Button)`
    margin: 1rem 0;
    font-weight: ${(props: Props) => props.theme.font.weight.bold};
`;

export const StyledEmailHighlight = styled.span<Props>`
  font-weight: ${(props) => props.theme.font.weight.bold};
  color: ${(props) => props.theme.palette.primary._500};
`;
